import { useEffect } from 'react';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import routes from './config/routes';
import useUserStore from './store/userStore';
import FeatureProvider from './components/FeatureProvider';
import './styles/index.css';

const AppRoutes = () => {
  const element = useRoutes(routes);
  return element;
};

const App = () => {
  const fetchUser = useUserStore((state) => state.fetchUser);

  // Fetch user info khi app mount (nếu có token)
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <ConfigProvider>
      <AntApp>
        <FeatureProvider>
          <Router>
            <AppRoutes />
          </Router>
        </FeatureProvider>
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
